import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Select from "react-select";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";
import Pagination from "../../common/Pagination/Pagination";
import { Translate } from "../../Enums/Tranlate";
import CardItem from "./CardItem";
import AddAllowancesModal from "./AddAllowancesModal";
import "./style.scss";
import AllowanceService from "../../../services/AllowanceService";
import HasAllowances from "./HasAllowances";
import AllowanceSettingsService from "../../../services/HRM/AllowanceSettingsService";
import EmployeesService from "../../../services/HRM/EmployeesService";
import ScrollPagination from "../../common/ScrollPagination";

const Allowances = () => {
	const [data, setData] = useState([]);
	const [addModal, setAddModal] = useState(false);
	const [item, setItem] = useState({});
	const [hasData, setHasData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const allowanceService = new AllowanceService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const tabs = ["allowances", "allowances_setting"];
	const [selectTab, setSelectTab] = useState("allowances");

	// ── Allowance Settings tab ───────────────────────────────
	const [allowanceSettings, setAllowanceSettings] = useState({
		vacationsEnabled: false,
		sickLeaveEnabled: false,
		excludedEmployeesEnabled: false,
		allowancesInVacations: [],
		allowancesNotInVacations: [],
		allowancesInSickLeave: [],
		allowancesNotInSickLeave: [],
		excludedEmployees: [],
	});
	const [allAllowances, setAllAllowances] = useState([]);
	const [loadingAllowance, setLoadingAllowance] = useState(false);
	const [savingAllowance, setSavingAllowance] = useState(false);

	useEffect(() => {
		if (selectTab !== "allowances_setting") return;
		setLoadingAllowance(true);
		Promise.all([
			new AllowanceSettingsService().getSettings(),
			new AllowanceService().getList({ page: 1, limit: 1000 }),
		])
			.then(([allowRes, allRes]) => {
				if (allowRes?.status === 200) {
					setAllowanceSettings(allowRes?.data?.data);
				}
				if (allRes?.status === 200) {
					const items =
						allRes?.data?.data?.data ||
						allRes?.data?.data ||
						allRes?.data ||
						[];
					setAllAllowances(items.map((a) => ({ label: a.name, value: a.id })));
				}
			})
			.catch((err) => {
				console.error(err);
			})
			.finally(() => setLoadingAllowance(false));
	}, [selectTab]);

	const saveAllowanceSettings = () => {
		setSavingAllowance(true);
		const d = allowanceSettings;
		const data = {
			vacationsEnabled: d.vacationsEnabled,
			sickLeaveEnabled: d.sickLeaveEnabled,
			excludedEmployeesEnabled: d.excludedEmployeesEnabled,
			allowancesInVacations: (d.allowancesInVacations || []).map(
				(a) => a.id || a,
			),
			allowancesNotInVacations: (d.allowancesNotInVacations || []).map(
				(a) => a.id || a,
			),
			allowancesInSickLeave: (d.allowancesInSickLeave || []).map(
				(a) => a.id || a,
			),
			allowancesNotInSickLeave: (d.allowancesNotInSickLeave || []).map(
				(a) => a.id || a,
			),
			excludedEmployeeIds: (d.excludedEmployees || []).map((e) => e.id || e),
		};
		new AllowanceSettingsService()
			.updateSettings(data)
			.then((res) => {
				if (res?.status === 200)
					toast.success(Translate[lang]?.updated_successfully);
			})
			.finally(() => setSavingAllowance(false));
	};

	const toSelectValues = (arr) =>
		(arr || []).map((a) => ({ label: a.name, value: a.id }));

	const fromSelectValues = (selected) =>
		(selected || []).map((s) => ({ id: s.value, name: s.label }));

	const inVacationsIds = (allowanceSettings.allowancesInVacations || []).map(
		(a) => a.id || a.value,
	);
	const notInVacationsIds = (
		allowanceSettings.allowancesNotInVacations || []
	).map((a) => a.id || a.value);
	const inSickLeaveIds = (allowanceSettings.allowancesInSickLeave || []).map(
		(a) => a.id || a.value,
	);
	const notInSickLeaveIds = (
		allowanceSettings.allowancesNotInSickLeave || []
	).map((a) => a.id || a.value);

	const inVacationsOpts = allAllowances.filter(
		(opt) => !notInVacationsIds.includes(opt.value),
	);
	const notInVacationsOpts = allAllowances.filter(
		(opt) => !inVacationsIds.includes(opt.value),
	);
	const inSickLeaveOpts = allAllowances.filter(
		(opt) => !notInSickLeaveIds.includes(opt.value),
	);
	const notInSickLeaveOpts = allAllowances.filter(
		(opt) => !inSickLeaveIds.includes(opt.value),
	);
	// ────────────────────────────────────────────────────────

	return (
		<div className="department">
			<Card className="mb-3">
				<Card.Body className="search-card d-flex justify-content-between p-3 align-items-center">
					<div className="input-group w-75">
						<div className="custom-tabs-div">
							{tabs?.map((tab, index) => {
								return (
									<p
										key={index}
										className={`${tab === selectTab ? "activeP" : ""}`}
										onClick={() => setSelectTab(tab)}>
										<span></span> {Translate[lang][tab]}
									</p>
								);
							})}
						</div>
					</div>
					{selectTab === "allowances" && (
						<div className="add-department">
							<Button
								variant="primary"
								className="me-2 h-75"
								onClick={() => {
									setItem({});
									setAddModal(true);
								}}>
								<i className="la la-plus mx-1"></i>
								{Translate[lang]?.add} {Translate[lang]?.allowances}
							</Button>
						</div>
					)}
				</Card.Body>
			</Card>

			{selectTab === "allowances" && (
				<Row>
					<Col lg={12}>
						<Card>
							<Card.Body className={`${hasData === 0 && "text-center"} `}>
								{loading && (
									<div style={{ height: "300px" }}>
										<Loader />
									</div>
								)}
								{hasData === 1 && !loading && (
									<Table responsive>
										<thead>
											<tr className="text-center">
												<th>
													<strong>{Translate[lang]?.name}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.fees}</strong>
												</th>
												{selectTab === "has_allowances" && <th></th>}
												{selectTab !== "has_allowances" && <th></th>}
											</tr>
										</thead>

										<tbody className="table-body">
											{data?.map((item, index) => {
												return (
													<CardItem
														index={index}
														key={index}
														item={item}
														setItem={setItem}
														selectTab={selectTab}
														setAddModal={setAddModal}
														setShouldUpdate={setShouldUpdate}
													/>
												);
											})}
										</tbody>
									</Table>
								)}
								{hasData === 0 && <NoData />}
								<Pagination
									setData={setData}
									service={allowanceService}
									shouldUpdate={shouldUpdate}
									setHasData={setHasData}
									setLoading={setLoading}
								/>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			)}

			{/* {selectTab === "has_allowances" && <HasAllowances />} */}

			{selectTab === "allowances_setting" && (
				<Card>
					<Card.Body>
						{loadingAllowance ? (
							<div style={{ height: "300px" }}>
								<Loader />
							</div>
						) : (
							<>
								<Row className="mb-5">
									<Col md={4}>
										<label
											htmlFor="vacationsEnabled"
											className="mb-0 d-flex gap-3">
											<div className="form-check form-switch mb-0">
												<input
													className="form-check-input"
													type="checkbox"
													id="vacationsEnabled"
													checked={allowanceSettings.vacationsEnabled}
													onChange={(e) =>
														setAllowanceSettings((p) => ({
															...p,
															vacationsEnabled: e.target.checked,
														}))
													}
												/>
											</div>
											{Translate[lang]?.vacations_enabled}
										</label>
									</Col>
									<Col md={4}>
										<label
											htmlFor="sickLeaveEnabled"
											className="mb-0 d-flex gap-3">
											<div className="form-check form-switch mb-0">
												<input
													className="form-check-input"
													type="checkbox"
													id="sickLeaveEnabled"
													checked={allowanceSettings.sickLeaveEnabled}
													onChange={(e) =>
														setAllowanceSettings((p) => ({
															...p,
															sickLeaveEnabled: e.target.checked,
														}))
													}
												/>
											</div>
											{Translate[lang]?.sick_leave_enabled}
										</label>
									</Col>
									<Col md={4}>
										<label
											htmlFor="excludedEmployeesEnabled"
											className="d-flex gap-3 mb-0">
											<div className="form-check form-switch mb-0">
												<input
													className="form-check-input"
													type="checkbox"
													id="excludedEmployeesEnabled"
													checked={allowanceSettings.excludedEmployeesEnabled}
													onChange={(e) =>
														setAllowanceSettings((p) => ({
															...p,
															excludedEmployeesEnabled: e.target.checked,
														}))
													}
												/>
											</div>
											{Translate[lang]?.excluded_employees_enabled}
										</label>
									</Col>
								</Row>

								<Row>
									<Col md={6} className="mb-3">
										<label className="text-label">
											{Translate[lang]?.allowances_in_vacations}
										</label>
										<Select
											isMulti
											options={inVacationsOpts}
											value={toSelectValues(
												allowanceSettings.allowancesInVacations,
											)}
											onChange={(sel) =>
												setAllowanceSettings((p) => ({
													...p,
													allowancesInVacations: fromSelectValues(sel),
												}))
											}
											placeholder={Translate[lang]?.select}
										/>
									</Col>
									<Col md={6} className="mb-3">
										<label className="text-label">
											{Translate[lang]?.allowances_not_in_vacations}
										</label>
										<Select
											isMulti
											options={notInVacationsOpts}
											value={toSelectValues(
												allowanceSettings.allowancesNotInVacations,
											)}
											onChange={(sel) =>
												setAllowanceSettings((p) => ({
													...p,
													allowancesNotInVacations: fromSelectValues(sel),
												}))
											}
											placeholder={Translate[lang]?.select}
										/>
									</Col>
									<Col md={6} className="mb-3">
										<label className="text-label">
											{Translate[lang]?.allowances_in_sick_leave}
										</label>
										<Select
											isMulti
											options={inSickLeaveOpts}
											value={toSelectValues(
												allowanceSettings.allowancesInSickLeave,
											)}
											onChange={(sel) =>
												setAllowanceSettings((p) => ({
													...p,
													allowancesInSickLeave: fromSelectValues(sel),
												}))
											}
											placeholder={Translate[lang]?.select}
										/>
									</Col>
									<Col md={6} className="mb-3">
										<label className="text-label">
											{Translate[lang]?.allowances_not_in_sick_leave}
										</label>
										<Select
											isMulti
											options={notInSickLeaveOpts}
											value={toSelectValues(
												allowanceSettings.allowancesNotInSickLeave,
											)}
											onChange={(sel) =>
												setAllowanceSettings((p) => ({
													...p,
													allowancesNotInSickLeave: fromSelectValues(sel),
												}))
											}
											placeholder={Translate[lang]?.select}
										/>
									</Col>
									{allowanceSettings?.excludedEmployeesEnabled && (
										<Col md={12} className="mb-3">
											<label className="text-label">
												{Translate[lang]?.excluded_employees}
											</label>
											<ScrollPagination
												isMulti
												Service={new EmployeesService()}
												value={toSelectValues(
													allowanceSettings.excludedEmployees,
												)}
												nameVal={"name"}
												setData={(e) =>
													setAllowanceSettings((p) => ({
														...p,
														excludedEmployees: fromSelectValues(e),
													}))
												}
											/>
										</Col>
									)}
								</Row>

								<Button
									variant="primary"
									onClick={saveAllowanceSettings}
									disabled={savingAllowance}>
									{savingAllowance ? (
										<span className="spinner-border spinner-border-sm" />
									) : (
										Translate[lang]?.save
									)}
								</Button>
							</>
						)}
					</Card.Body>
				</Card>
			)}

			{addModal && (
				<AddAllowancesModal
					item={item}
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
				/>
			)}
		</div>
	);
};

export default Allowances;
